(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["snv-product"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const thumb = event.target.closest('[data-snv-thumb]');
    if (!thumb) return;
    const section = thumb.closest('[data-snv-product]');
    const image = section && section.querySelector('.snv-product__main-image img');
    if (!image) return;
    image.src = thumb.dataset.imageUrl;
    image.srcset = '';
    image.alt = thumb.dataset.imageAlt || image.alt;
    section.querySelectorAll('[data-snv-thumb]').forEach(function (button) {
      const active = button === thumb;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["somnova-category-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-somnova-finder]').forEach((finder) => {
      const questions = [...finder.querySelectorAll('[data-quiz-question]')];
      const outcomes = [...finder.querySelectorAll('[data-quiz-outcome]')];
      const result = finder.querySelector('[data-quiz-result]');
      const progress = finder.querySelector('[data-quiz-progress]');
      const total = finder.querySelector('[data-quiz-total]');
      const reset = finder.querySelector('[data-quiz-reset]');
      let answers = [];

      if (!questions.length || !outcomes.length) return;
      total.textContent = questions.length;

      const showQuestion = (index) => {
        questions.forEach((question, questionIndex) => {
          const active = questionIndex === index;
          question.hidden = !active;
          question.classList.toggle('is-active', active);
        });
        result.hidden = true;
        progress.style.width = `${(index / questions.length) * 100}%`;
      };

      const showOutcome = () => {
        const selected = answers.map((answer) => answer.value);
        let matched = outcomes.find((outcome) => {
          const values = outcome.dataset.match.split(',').map((value) => value.trim()).filter(Boolean);
          return values.length && values.every((value) => selected.includes(value));
        });
        if (!matched) matched = outcomes.find((outcome) => outcome.dataset.default === 'true') || outcomes[0];
        outcomes.forEach((outcome) => { outcome.hidden = outcome !== matched; });
        questions.forEach((question) => { question.hidden = true; });
        result.hidden = false;
        reset.hidden = false;
        progress.style.width = '100%';
      };

      finder.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quiz-choice]');
        if (!button) return;
        const question = button.closest('[data-quiz-question]');
        const index = Number(question.dataset.questionIndex) - 1;
        answers[index] = { value: button.dataset.value };
        if (index + 1 < questions.length) showQuestion(index + 1);
        else showOutcome();
      });

      reset.addEventListener('click', () => {
        answers = [];
        reset.hidden = true;
        showQuestion(0);
      });

      showQuestion(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
